import area from "@/assets/json/area.json";

export class AreaTool {
    static convertStrToId(province, city, district) {
        let provinceObject, cityObject, districtObject = null
        provinceObject = area.filter((item) => item.label == province)[0]
        if(provinceObject) {    
            cityObject = provinceObject?.children.filter((item) => item.label == city)[0]
        }
        if(cityObject) {
            districtObject = cityObject?.children.filter((item) => item.label == district)[0]
        }
        return [provinceObject?.value || "", cityObject?.value || "", districtObject?.value || ""]
    }

    static convertIdToStr(areaIdArray) {
        const province = area.filter((item) => item.value == areaIdArray[0])[0]
        let city = null
        if(province) {  
            city = province.children.filter((item) => item.value == areaIdArray[1])[0]
        }
        let district = null
        if(city) {
            district = city.children.filter((item) => item.value == areaIdArray[2])[0]
        }
        return [province?.label || "", city?.label || "", district?.label || "" ]
    }
}